export const URL_CONTENTFUL_ENTRIES = 'https://preview.contentful.com/spaces/a9mooz6ri0vn/environments/master/entries/'
export const URL_CONTENTFUL_ASSETS = 'https://preview.contentful.com/spaces/a9mooz6ri0vn/environments/master/assets/'
export const URL_CONTENTFUL_ARTICLE_SLUG = 'https://preview.contentful.com/spaces/a9mooz6ri0vn/environments/master/entries?content_type=article&fields.slug='
